import * as utils from './Utils';


function deserializeProductPrice(product) {
  if (product.currency === window.OnVoardData.currency_selector.active_currency_code) return;
  import('common/bigcommerce-utils')
  .then((bcUtils) => {
    product.setCurrency(window.OnVoardData.currency_selector.active_currency_code);
    product.setPrice(bcUtils.convertActiveRate(product.price));
    product.setCompareAtPrice(bcUtils.convertActiveRate(product.compareAtPrice));
    product.setDiscountAmount(bcUtils.convertActiveRate(product.discountAmount));

    if (product.variants && product.variants.length > 0) {
      product.variants.forEach((variant) => {
        variant.setPrice(bcUtils.convertActiveRate(variant.price));
        variant.setCompareAtPrice(bcUtils.convertActiveRate(variant.compareAtPrice));
      })
    }
  });
}


export function fetchProductPrices(products, callback) {
  const product = products[0];
  if (!product) {
    callback();
    return;
  }

  products.forEach((product) => {
    deserializeProductPrice(product)
  })

  callback();
}
